/**
 * Copy for the `?sso_error=<code>` the backend's Google SSO callback appends
 * to `/login` when a sign-in fails.
 *
 * Mirrors `SsoErrorCode` in `backend/src/ai_first_workflow_designer/api/models.py`
 * (the callback is not in the OpenAPI schema, so keep the two lists in sync).
 */

export const SSO_ERROR_CODES = [
  "cancelled",
  "expired",
  "not_boi_account",
  "email_not_verified",
  "account_disabled",
  "unavailable",
  "failed",
] as const;

export type SsoErrorCode = (typeof SSO_ERROR_CODES)[number];

const SSO_ERROR_MESSAGES: Record<SsoErrorCode, string> = {
  cancelled: "Google sign-in was cancelled. Try again when you're ready.",
  expired: "That sign-in attempt expired. Please start again with the Google button.",
  not_boi_account:
    "Google sign-in is for Board of Innovation accounts. Clients sign in with email and password.",
  email_not_verified: "Google hasn't verified this email address yet, so we can't sign you in.",
  account_disabled: "This account has been deactivated. Contact your BOI admin.",
  unavailable: "BOI sign-in is temporarily unavailable. Please try again in a moment.",
  failed: "Google sign-in didn't complete. Please try again.",
};

/** True when `value` is one of the known SSO error codes. */
export function isSsoErrorCode(value: string): value is SsoErrorCode {
  return (SSO_ERROR_CODES as readonly string[]).includes(value);
}

/** The message to show for an `sso_error` value (unknown codes get a fallback). */
export function ssoErrorMessage(code: string): string {
  return isSsoErrorCode(code) ? SSO_ERROR_MESSAGES[code] : SSO_ERROR_MESSAGES.failed;
}
